import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { loginAdmin } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await loginAdmin(email.trim(), password);
      toast.success("Welcome, Admin");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.message?.replace("Firebase: ", "") || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="container-nc py-20 min-h-[70vh] grid place-items-center">
      <div className="w-full max-w-md bg-ivory border border-line rounded-2xl p-10 shadow-soft">
        <div className="w-11 h-11 rounded-full gold-border flex items-center justify-center mx-auto mb-5">
          <Lock size={16} className="text-gold" strokeWidth={1.5} />
        </div>
        <p className="overline text-center mb-3">Restricted area</p>
        <h1 className="font-serif text-3xl md:text-4xl text-espresso text-center leading-tight">
          Admin Sign In
        </h1>
        <p className="text-muted_brown text-center mt-3 text-sm">
          Note Console operations dashboard.
        </p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <input
            required
            type="email"
            placeholder="Admin email"
            className="input-nc bg-cream"
            data-testid="admin-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            required
            type="password"
            placeholder="Password"
            className="input-nc bg-cream"
            data-testid="admin-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            disabled={loading}
            data-testid="admin-submit"
            className="btn-primary w-full disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In as Admin"}
          </button>
        </form>

        <p className="text-xs text-muted_brown text-center mt-6">
          <Link to="/" className="underline">Back to store</Link>
        </p>
      </div>
    </div>
  );
}
